import React from 'react';
import {Popup} from 'semantic-ui-react';

import PopupTable from '@appComponents/PopupTable';
import {renderDescription} from '@utils/tableHelpers';
import {AvatarTournamentCategory} from '@modules/events/views/common/AvatarTournamentCategory';
import {CopyTextIcon} from '@utils/CopyTextIcon';
import LinkWithAuthorization from '@appComponents/LinkWithAuthorization';
import {PROPERTY_LICENCE} from '@constants/resources';
import {EVENT_TYPE_SPORTRADAR, EVENT_TYPE_STAGE, SECURITY_PRIVILEGES_UPDATE} from '@constants/variables';

export const renderIdWithCopyIcon = (id) => (
    <>
        {id}
        <CopyTextIcon value={String(id)} iconTitle={'Copy ID'} disabled />
    </>
);

export const buildPropertyLicencePopupRow = (row, {coalesceLicensorName = true} = {}) => ({
    header: 'Property licence',
    body: (
        <LinkWithAuthorization
            link={{
                name: 'propertyLicences.edit',
                params: {id: row.property_licence_id},
            }}
            newWindow={true}
            authorization={{
                [PROPERTY_LICENCE]: SECURITY_PRIVILEGES_UPDATE,
            }}
        >
            {`${row.property_licence_name} - ${coalesceLicensorName ? (row.licensor_name ?? '') : row.licensor_name}`}
        </LinkWithAuthorization>
    ),
});

export const buildNotesPopupRow = (row) => ({
    header: 'Notes',
    body: row.event_notes
        ? row.event_notes.split('\n').map((line, index) => (<div key={index}>{line}</div>))
        : null,
    hidden: !row.event_notes,
});

export const buildEventIdPopupRow = (row) => ({
    header: 'Event ID',
    body: renderIdWithCopyIcon(row.event_id),
});

export const buildMatchIdPopupRow = (row) => ({
    header: 'Match ID',
    body: row.match_id ? renderIdWithCopyIcon(row.match_id) : '-',
    hidden: EVENT_TYPE_SPORTRADAR !== row.event_type_id,
});

export const buildStageIdPopupRow = (row) => ({
    header: 'Stage ID',
    body: row.stage_id ? renderIdWithCopyIcon(row.stage_id) : '-',
    hidden: EVENT_TYPE_STAGE !== row.event_type_id,
});

export const renderFirstLinePopup = ({rowId, keyPrefix, trigger, rows}) => (
    <Popup
        className='--noPadding'
        key={`${keyPrefix}-${rowId}`}
        trigger={trigger}
        flowing
        hoverable
    >
        <PopupTable rows={rows}/>
    </Popup>
);

export const renderEventSecondLine = (event, rowId, keyPrefix) => (
    <AvatarTournamentCategory
        event={event}
        key={`${keyPrefix}-${rowId}`}
    />
);

export const renderEventThirdLine = (
    row,
    {
        omit = false,
        keyPrefix = 'description',
        requireNonEmptyDescription = false,
    } = {}
) => {
    if (omit) {
        return null;
    }

    const hasDescription = null !== row.event_description
        && (!requireNonEmptyDescription || '' !== row.event_description);

    if (!hasDescription) {
        return null;
    }

    return (
        <div key={`${keyPrefix}-${row.id}`}>
            {renderDescription(row.event_description, row.event_color, row.event_external_description)}
        </div>
    );
};
